export const methodSetUrlFragment = (fragment: string | Record<string, string>, value?: any) => {
  const router = useRouter();
  const currentQuery = router.currentRoute.value.query;
  const newQuery = { ...currentQuery };

  if (typeof fragment === 'string') {
    newQuery[fragment] = value as any;
  } else if (typeof fragment === 'object') {
    Object.keys(fragment).forEach(key => {
      newQuery[key] = fragment[key];
    });
  }

  router.replace({
    name: router.currentRoute.value.name,
    query: newQuery
  });
}

export const methodGetUrlFragment = (fragment: string, defaultValue: any = null) => {
  if (!fragment) {
    return defaultValue;
  }

  const currentQuery = useRouter()?.currentRoute?.value?.query ?? {};
  return currentQuery?.[fragment] || defaultValue || null;
}


export const linkString = (word: string, url: string|any, click: any = null) => {
  if (!url) {
    return word;
  }

  // remove double slashes
  if (url.includes('//')) {
    url = url.replace(/\/\//g, '/');
  }

  url = useLocalePath()(url)

  setTimeout(() => {
    const el = document?.querySelector(`[data-linkedstring="${word}"]`);
    if (el) {
      const clickHandler = (e: Event) => {
        e.preventDefault();

        if (typeof click === 'function') {
          click(e);
        }else{
          const router = useRouter();
          router.push(url)
        }
      }

      (!el.hasAttribute('data-listened'))
        ? el.addEventListener('click', clickHandler)
        : el.removeEventListener('click', clickHandler);

      // add data attribute marking it as listened
      el.setAttribute('data-listened', 'true');
    }
  }, 300)

  return `  <a data-linkedstring="${word}" href="${url}" class="ui-link blue">${word}</a>  `;
}

export const isRouteActive = (route: string|object, startswith = false) => {
  const router = useRouter();
  const currentPath = unlocalizeUrl(router.currentRoute.value.path);

  if (typeof route === 'string') {
    if (startswith) {
      return currentPath.startsWith(route);
    } else {
      return currentPath === route;
    }
  } else if (typeof route === 'object') {
    const routePath = route.path || '';
    if (startswith) {
      return currentPath.startsWith(routePath);
    } else {
      return currentPath === routePath;
    }
  }

  return false;
}
